import OperationRepository from '@/libs/customAxios/operationAxios'

const alertResource = '/superadmin/tenants/banner_alerts/details'

export default {
  getBannerAlerts() {
    return OperationRepository.get(`${alertResource}`)
  },
}
